import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

import DialogHeader from "../components/DialogHeader"

export default function ConfirmDeleteTasksDialog({ open, onClose, taskCount }) {
  function handleSoftClose() {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader
        title={`Delete ${taskCount} tasks?`}
        onClose={handleSoftClose}
      />
      <DialogContent>
        <Typography variant="body1" color="text.secondary">
          This will delete the tasks from the candidates pages.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={() => onClose(true)}>
          Confirm delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
